var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.checkProgress === false
      ? _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "abnormalPackageMarkRef",
                attrs: {
                  model: _vm.abnormalPackageMarkForm,
                  "label-position": "top",
                  size: "small",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Resource.anJunWaybillNumber"),
                              prop: "waybillNumber",
                              rules: {
                                required: true,
                                message: _vm.$t("collectionCenter.notNull"),
                                trigger: ["blur"],
                              },
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { type: "textarea", rows: 5 },
                              model: {
                                value:
                                  _vm.abnormalPackageMarkForm.waybillNumber,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.abnormalPackageMarkForm,
                                    "waybillNumber",
                                    $$v
                                  )
                                },
                                expression:
                                  "abnormalPackageMarkForm.waybillNumber",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "collectionCenter.ReasonForAbnormal"
                              ),
                              prop: "reasonForAbnormal",
                              rules: {
                                required: true,
                                message: _vm.$t("collectionCenter.notNull"),
                                trigger: ["blur", "change"],
                              },
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "GlobalSetObj.pleaseChoose"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value:
                                    _vm.abnormalPackageMarkForm
                                      .reasonForAbnormal,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.abnormalPackageMarkForm,
                                      "reasonForAbnormal",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "abnormalPackageMarkForm.reasonForAbnormal",
                                },
                              },
                              [
                                _c("el-option", {
                                  key: 1,
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.CustomerRequiresInterceptionReturn"
                                    ),
                                    value: "customer_reject",
                                  },
                                }),
                                _c("el-option", {
                                  key: 2,
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.ReceivingCustomerRejectsReturn"
                                    ),
                                    value: "intercept_return",
                                  },
                                }),
                                _c("el-option", {
                                  key: 3,
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.PackageDamagedReturn"
                                    ),
                                    value: "damage_return",
                                  },
                                }),
                                _c("el-option", {
                                  key: 4,
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.PackageLost"
                                    ),
                                    value: "lost_return",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("collectionCenter.AbnormalRemarks"),
                              prop: "remark",
                              rules: {
                                required: true,
                                message: _vm.$t("collectionCenter.notNull"),
                                trigger: ["blur"],
                              },
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                "show-word-limit": "",
                                maxlength: 200,
                                rows: 5,
                              },
                              model: {
                                value: _vm.abnormalPackageMarkForm.remark,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.abnormalPackageMarkForm,
                                    "remark",
                                    $$v
                                  )
                                },
                                expression: "abnormalPackageMarkForm.remark",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.checkProgress === true
      ? _c(
          "div",
          { staticStyle: { padding: "20px 0" } },
          [
            _c("div", { staticStyle: { "text-align": "right" } }, [
              _vm._v(_vm._s(_vm.abnormalPackageMarkResult.percentage) + "%"),
            ]),
            _c("el-progress", {
              attrs: {
                "show-text": false,
                "text-inside": false,
                "stroke-width": 20,
                percentage: _vm.abnormalPackageMarkResult.percentage,
                status: "success",
              },
            }),
            _vm.abnormalPackageMarkResult.percentage === 100
              ? _c("div", { staticStyle: { "font-size": "16px" } }, [
                  _c("div", { staticStyle: { margin: "20px 0" } }, [
                    _c("span", { staticStyle: { "margin-right": "20px" } }, [
                      _vm._v(_vm._s(_vm.$t("GlobalSetObj.succeed")) + "："),
                      _c("span", { staticStyle: { color: "#67c23a" } }, [
                        _vm._v(_vm._s(_vm.abnormalPackageMarkResult.success)),
                      ]),
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("GlobalSetObj.Lose")) + "："),
                      _c("span", { staticStyle: { color: "#bd2c00" } }, [
                        _vm._v(_vm._s(_vm.abnormalPackageMarkResult.fail)),
                      ]),
                    ]),
                  ]),
                  _vm.abnormalPackageMarkResult.errorList.length > 0
                    ? _c("div", [
                        _c("div", { staticStyle: { "margin-bottom": "6px" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("collectionCenter.FailureDetails")) +
                              "："
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "max-height": "200px",
                              "overflow-y": "auto",
                            },
                          },
                          _vm._l(
                            _vm.abnormalPackageMarkResult.errorList,
                            function (item, index) {
                              return _c("div", { key: index }, [
                                _vm._v(_vm._s(item)),
                              ])
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticStyle: { "text-align": "right" } },
      [
        _c(
          "el-button",
          {
            attrs: { size: "small" },
            on: {
              click: function ($event) {
                return _vm.confirmAbnormalPackageMarkData(1)
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("orderExport.close")) + " ")]
        ),
        _vm.checkProgress === false
          ? _c(
              "el-button",
              {
                attrs: { size: "small", type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.confirmAbnormalPackageMarkData(2)
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("collectionCenter.confirm")) + " ")]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }